export default {"src":"/_next/static/media/effective-circular-icon.8b858b62.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};